var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavHomeOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.18579 9.6572C3.06333 9.9211 2.99993 10.2085 3 10.4995V20.4995C3 21.0518 3.44772 21.4995 4 21.4995H8C8.55228 21.4995 9 21.0518 9 20.4995V14.4995C9 13.9472 9.44772 13.4995 10 13.4995H14C14.5523 13.4995 15 13.9472 15 14.4995V20.4995C15 21.0518 15.4477 21.4995 16 21.4995L20 21.4995C20.5523 21.4995 21 21.0518 21 20.4995V10.4995C21.0001 10.2085 20.9367 9.9211 20.8142 9.6572C20.6918 9.39329 20.5132 9.15928 20.291 8.97148L13.291 2.97248C12.93 2.66739 12.4726 2.5 12 2.5C11.5274 2.5 11.07 2.66739 10.709 2.97248L3.709 8.97148C3.4868 9.15928 3.30824 9.39329 3.18579 9.6572Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavHomeOff);
export default __webpack_public_path__ + "static/media/nav_home_off.6c8b9a9991cd43418df933585b35b901.svg";
export { ForwardRef as ReactComponent };